import Vue from 'vue'
import Vuex from 'vuex'

// modules
import block from './block'
import screen from './screen'
import blocks from './blocks'
import podcasts from './podcasts'
import episodes from './episodes'
import crawltodo from './crawltodo'
import crawlerrors from './crawlerrors'

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  isLoading: false,
  error: false,
  warnings: [], // id, text, location
}

const getters = {
  isLoading: (state) => {
    return state.isLoading
  },

  checkWarning: (state) => (id) => {
    if (state.warnings.length === 0) return false
    // check for warning id's by type, id like `screen-12`, but not this id
    const type = id.substring(0, id.indexOf('-'))
    const warns = state.warnings.filter(warning => {
      if (warning.id !== id && String(warning.id).indexOf(type) > -1) {
        return warning
      }
    })
    if (warns && warns.length > 0) return true
    return false
  },

}

const actions = {
  throwError({ commit }, error) {
    commit('setError', error)
  },

  closeError({ commit }) {
    commit('setError', false)
  },

  issueWarning({ commit }, warning) {
    commit('addWarning', warning)
  },

  closeWarning({ commit }, id) {
    commit('removeWarning', id)
  },

  closeWarningsOfType({ commit, state }, type) {
    const warns = state.warnings.filter(warning => {
      if (String(warning.id).indexOf(type) > -1) {
        return warning
      }
    })
    warns.forEach(warning => commit('removeWarning', warning.id))
  },

  loading({ commit }, isLoading) {
    commit('loading', isLoading)
  },

}

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set(state, [variable, value]) {
    state[variable] = value
  },
  setError(state, error) {
    state.error = error
  },
  addWarning(state, warning) {
    state.warnings.push(warning)
  },
  removeWarning(state, id) {
    state.warnings = state.warnings.filter(it => it.id !== id)
  },
  loading(state, isLoading) {
    state.isLoading = isLoading
  }
}

export default new Vuex.Store({
  state,
  actions,
  getters,
  modules: { blocks, block, screen, podcasts, episodes, crawltodo, crawlerrors },
  mutations
})
